import { createAction } from '@reduxjs/toolkit';

import { pServices$filterQuery } from '@/api/services';
import { Category } from '@/types/category';
import { PServiceCardS } from '@/types/polako-services';

import { PServiceLoadArgs } from './polako-services.types';

export const pServiceKey = 'pServices';

export interface PServiceState {
    readonly queryString: string;
    readonly pServices: PServiceCardS[];
    readonly pServicesCounter: number;
    readonly pServiceCategories: Category[];
}

export enum PServicesActionTypes {
    pServicesLoad = 'pServices/pServicesLoad',
    pServicesLoadSuccess = 'pServices/pServicesLoadSuccess',
    pServicesIncreaseCounter = 'pServices/pServicesIncreaseCounter',
    pServiceLoadCategories = 'pServices/pServiceLoadCategories',
    pServiceLoadCategoriesSuccess = 'pServices/pServiceLoadCategoriesSuccess',

    // pServicesTranslationsLoad = 'pServices/translationsLoad',
    // pServicesTranslationsLoadSuccess = 'pServices/pServicesTranslationsLoadSuccess',
}

export const pServicesLoad = createAction<PServiceLoadArgs>(PServicesActionTypes.pServicesLoad);
export const pServicesLoadSuccess = createAction<PServiceCardS[]>(PServicesActionTypes.pServicesLoadSuccess);
export const pServicesIncreaseCounter = createAction(PServicesActionTypes.pServicesIncreaseCounter);
export const pServiceLoadCategories = createAction(PServicesActionTypes.pServiceLoadCategories);
export const pServiceLoadCategoriesSuccess = createAction<Category[]>(
    PServicesActionTypes.pServiceLoadCategoriesSuccess,
);

// export const pServicesTranslationsLoad = createAction<PServiceCardS[]>(PServicesActionTypes.pServicesTranslationsLoad);
// export const pServicesTranslationsLoadSuccess = createAction<PServiceCardS[]>(
//     PServicesActionTypes.pServicesTranslationsLoadSuccess,
// );

export type PServiceActions =
    | ReturnType<typeof pServicesLoad>
    | ReturnType<typeof pServicesLoadSuccess>
    | ReturnType<typeof pServicesIncreaseCounter>
    | ReturnType<typeof pServiceLoadCategories>
    | ReturnType<typeof pServiceLoadCategoriesSuccess>;
// | ReturnType<typeof pServicesTranslationsLoad>
// | ReturnType<typeof pServicesTranslationsLoadSuccess>;

export const PServicesQueryString = (payload: ReturnType<typeof pServicesLoad>['payload']): string =>
    pServices$filterQuery({
        locationCity: payload.locationCity,
        typeLanguage: payload.typeLanguage,
        countryCode: payload.countryCode,
    });
